<div *ngIf="notApproved" class="not-approved-header__container">
  <div class="not-approved-header__text">
    <div class="not-approved-header__title">Pending AOPA Staff Approval</div>
    <div class="not-approved-header__description">This page will not be visible to the public until AOPA staff approves it.</div>
  </div>
</div>
